import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';

class CancelButton extends React.Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {

    if (this.props.onClick) {
      return this.props.onClick;
    }

    this.props.history.push(this.props.path);
  }

  render() {
    return (
      <button type="button" onClick={this.handleClick}>{this.props.title}</button>
    );
  }
}

CancelButton.defaultProps = {
  title: "Cancel"
};

CancelButton.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default withRouter(CancelButton);



// WEBPACK FOOTER //
// ./src/components/form/controls/CancelButton.js